// extracted by mini-css-extract-plugin
export default {"appStickyHeader":"index_appStickyHeader__b9XiW"};